// This file is automatically generated by internal/scripts/refresh-assets.ts.
// Do not edit manually. Or do, I'm a comment, not a cop.

export const version = '4.5.10'
export const publishDates = {
	major: '2025-09-18T14:39:22.803Z',
	minor: '2026-03-18T11:05:13.340Z',
	patch: '2026-04-21T16:31:44.449Z',
}
